import queryString from 'query-string'

export const getSearchParams = search =>
  queryString.stringify({
    search,
    current: 1,
  })
